/* bb-track.js — Track Order lookup client. Posts {orderNumber,email} to the
   bb-track-order Worker and renders the shipment timeline. No dependencies. */
(function () {
  var root = document.querySelector('.tk');
  if (!root) return;
  var form = root.querySelector('.tk-form');
  var result = root.querySelector('#tk-result');
  var endpoint = (root.getAttribute('data-endpoint') || '').trim().replace(/\/+$/, '');
  var contactUrl = root.getAttribute('data-contact') || '';
  if (!form || !result) return;

  var btn = form.querySelector('.tk-btn');
  var btnLabel = btn ? btn.querySelector('.tk-btn-label') : null;
  var STEPS = ['Ordered', 'Pick & Pack', 'Shipped', 'Out for delivery', 'Delivered'];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtDate(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso);
      if (isNaN(d)) return '';
      return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    } catch (e) { return ''; }
  }
  function fmtETA(iso) {
    if (!iso) return '';
    try {
      var d = new Date(iso), now = new Date();
      var same = d.toDateString() === now.toDateString();
      var base = d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      return same ? 'Today, ' + d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : base;
    } catch (e) { return ''; }
  }

  function reveal(html) {
    result.innerHTML = '<div class="tk-result-inner tk-divider">' + html + '</div>';
    result.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { result.classList.add('is-open'); }); });
  }
  function timelineHTML(o) {
    var step = Math.max(0, Math.min(4, o.step | 0));
    var dates = ['', '', '', '', ''];
    dates[0] = fmtDate(o.placedAt);
    if (o.shippedAt) dates[2] = fmtDate(o.shippedAt);
    if (o.estimatedDeliveryAt) dates[4] = (step === 4 ? fmtDate(o.estimatedDeliveryAt) : 'Est. ' + fmtDate(o.estimatedDeliveryAt));
    var lis = STEPS.map(function (label, i) {
      var cls = i < step ? 'is-done' : (i === step ? (step === 4 ? 'is-done' : 'is-current') : '');
      return '<li class="tk-step ' + cls + '">' +
        '<span class="tk-dot"></span>' +
        '<span class="tk-step-label">' + esc(label) + '</span>' +
        (dates[i] ? '<span class="tk-step-date">' + esc(dates[i]) + '</span>' : '') +
        '</li>';
    }).join('');
    return '<ol class="tk-timeline" data-step="' + step + '">' + lis + '</ol>';
  }

  function detailsHTML(o) {
    var t = o.tracking || {};
    var carrier = t.company || (o.step >= 2 ? 'Shipped' : 'Preparing your order');
    var num = t.number ? '<div class="tk-detail-sub">' + esc(t.number) + '</div>' : '';
    var link = t.url ? '<a class="tk-track-link" href="' + esc(t.url) + '" target="_blank" rel="noopener">Track with carrier &rarr;</a>' : '';
    var eta = fmtETA(o.estimatedDeliveryAt);
    var etaCard = '<div class="tk-detail"><div class="tk-detail-label">Estimated delivery</div>' +
      '<div class="tk-detail-val">' + (eta ? esc(eta) : (o.step === 4 ? 'Delivered' : 'Updating soon')) + '</div>' +
      (o.step === 4 ? '<div class="tk-detail-sub">Your order was delivered.</div>' : '') + '</div>';
    var carrierCard = '<div class="tk-detail"><div class="tk-detail-label">Carrier &amp; tracking</div>' +
      '<div class="tk-detail-val">' + esc(carrier) + '</div>' + num + link + '</div>';
    return '<div class="tk-details">' + carrierCard + etaCard + '</div>';
  }

  function itemsHTML(o) {
    if (!o.items || !o.items.length) return '';
    var rows = o.items.map(function (it) {
      var thumb = it.image
        ? '<img class="tk-item-thumb" src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy" width="48" height="48">'
        : '<span class="tk-item-thumb tk-item-thumb--ph" aria-hidden="true"></span>';
      return '<div class="tk-item">' + thumb +
        '<span class="tk-item-name">' + esc(it.title) + '</span>' +
        '<span class="tk-item-qty">Qty ' + (parseInt(it.quantity, 10) || 1) + '</span></div>';
    }).join('');
    return '<div class="tk-items"><div class="tk-items-label">In this order</div>' + rows + '</div>';
  }

  function foundHTML(o) {
    var count = (o.items || []).reduce(function (n, it) { return n + (parseInt(it.quantity, 10) || 1); }, 0);
    var meta = [fmtDate(o.placedAt) ? 'Placed ' + fmtDate(o.placedAt) : '', count ? count + (count === 1 ? ' item' : ' items') : ''].filter(Boolean).join(' · ');
    var pillCls = 'tk-pill tk-pill--' + (o.step | 0);
    var head = '<div class="tk-order-head"><div>' +
      '<div class="tk-order-name">Order ' + esc(o.name) + '</div>' +
      (meta ? '<div class="tk-order-meta">' + esc(meta) + '</div>' : '') +
      '</div><span class="' + pillCls + '">' + esc(o.statusLabel || STEPS[o.step | 0]) + '</span></div>';
    var help = '<div class="tk-help">Something not right? ' +
      '<a href="' + esc(contactUrl || '/pages/contact-us-boost-blenz-detox') + '">Contact our team</a></div>';
    return head + timelineHTML(o) + detailsHTML(o) + itemsHTML(o) + help;
  }

  function msgHTML(text) {
    return '<div class="tk-msg"><p class="tk-msg-text">' + esc(text) +
      ' <a href="' + esc(contactUrl || '/pages/contact-us-boost-blenz-detox') + '">Contact us</a></p></div>';
  }

  function setLoading(on) {
    if (!btn) return;
    btn.disabled = on;
    if (btnLabel) btnLabel.textContent = on ? 'Searching…' : (btn.getAttribute('data-label') || 'Track order');
  }

  if (btnLabel) btn.setAttribute('data-label', btnLabel.textContent);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var order = (form.order && form.order.value || '').trim();
    var email = (form.email && form.email.value || '').trim();
    if (!order || !email) { reveal(msgHTML('Enter your order number and the email on the order.')); return; }
    if (!endpoint) { reveal(msgHTML('Order lookup is being set up.')); return; }

    setLoading(true);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ orderNumber: order, email: email })
    })
      .then(function (r) { return r.json().catch(function () { return { error: 'bad' }; }); })
      .then(function (data) {
        setLoading(false);
        if (data && data.found && data.order) reveal(foundHTML(data.order));
        else reveal(msgHTML((data && data.message) || "We couldn't find that order. Double-check your order number and email."));
      })
      .catch(function () {
        setLoading(false);
        reveal(msgHTML('Something went wrong looking up your order. Please try again shortly.'));
      });
  });
})();
